export const en = {
    title: `Edit Profile`,
    updated: `Profile updated successfully!`,
    save: `Save Changes`,
    saving: `Saving...`,
    failure: `Profile update failed`,
};
//# sourceMappingURL=en.js.map